/* TXR POWER — global theme behaviours */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.mq-track').forEach((el) => { el.style.animation = 'none'; });
  }

  /* Mobile nav drawer toggle ------------------------------------------------
     Any element with [data-mobile-nav-toggle] (hamburger, close button, backdrop)
     toggles the drawer with [data-mobile-nav-drawer]. */
  const drawer = document.querySelector('[data-mobile-nav-drawer]');
  const toggles = document.querySelectorAll('[data-mobile-nav-toggle]');
  function setOpen(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('no-scroll', open);
    toggles.forEach((t) => {
      // Only flip aria-expanded on the hamburger (not the close/backdrop)
      if (t.classList && t.classList.contains('mobile-nav__toggle')) {
        t.setAttribute('aria-expanded', String(open));
      }
    });
  }
  toggles.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      setOpen(!(drawer && drawer.classList.contains('is-open')));
    });
  });
  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) setOpen(false);
  });
  // Close when a link inside the drawer is followed (so navigation feels clean)
  if (drawer) {
    drawer.querySelectorAll('a').forEach((a) => {
      a.addEventListener('click', () => setOpen(false));
    });
  }

  /* Newsletter micro-validation -------------------------------------------- */
  document.querySelectorAll('form[data-newsletter]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      const email = form.querySelector('input[type="email"]');
      if (!email) return;
      if (!email.value.trim()) { e.preventDefault(); email.focus(); }
    });
  });

  /* Reveal on scroll -------------------------------------------------------- */
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { e.target.classList.add('is-in-view'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 })
    : null;
  if (io) document.querySelectorAll('[data-reveal]').forEach((el) => io.observe(el));
})();
